export enum DocumentType {
    MigratedVisitRecord = 1,
    MedicalDocument = 2,
    Photo = 3,
    Other = 4,
    DentalChart = 5,
    Anesthesia = 6,
    TreatmentPlanConsent = 7,
    DischargeAgainstMedicalAdviceConsent = 8,
    ClientConsent = 9,
    DentalExtractionsConsent = 10,
    EuthanasiaConsent = 11,
    TreatmentConsent = 12,
    SurgeryConsent = 13,
    Diagnostics = 14,
    OutsidePrescription = 15,
    UltrasoundRadiology = 16
}

export const ConsentDocumentTypes = [
    DocumentType.TreatmentPlanConsent,
    DocumentType.DischargeAgainstMedicalAdviceConsent,
    DocumentType.ClientConsent,
    DocumentType.DentalExtractionsConsent,
    DocumentType.EuthanasiaConsent,
    DocumentType.TreatmentConsent,
    DocumentType.SurgeryConsent
];

export namespace DocumentType {
    export const displayName = (documentType: DocumentType) => {
        switch (documentType) {
            case DocumentType.MigratedVisitRecord: return "Migrated Visit Record";
            case DocumentType.MedicalDocument: return "Previous Medical Records";
            case DocumentType.Photo: return "Pictures";
            case DocumentType.Other: return "Other";
            case DocumentType.DentalChart: return "Dental Chart";
            case DocumentType.Anesthesia: return "Anesthesia";
            case DocumentType.TreatmentPlanConsent: return "Treatment Plan Consent";
            case DocumentType.DischargeAgainstMedicalAdviceConsent: return "Discharge Against Medical Advice Consent";
            case DocumentType.ClientConsent: return "Client Consent";
            case DocumentType.DentalExtractionsConsent: return "Dental Extractions Consent";
            case DocumentType.EuthanasiaConsent: return "Euthanasia Consent";
            case DocumentType.TreatmentConsent: return "Treatment Consent";
            case DocumentType.SurgeryConsent: return "Surgery Consent";
            case DocumentType.Diagnostics: return "Diagnostics";
            case DocumentType.OutsidePrescription: return "Outside Prescription";
            case DocumentType.UltrasoundRadiology: return "Ultrasound / Radiology";
            default: return "";
        }
    }
}
